//

import { createAsyncThunk } from '@reduxjs/toolkit'
import { gatewayRequestAxios } from '../../services/interceptor'

import { GATEWAY_API_USER_URL, GATEWAY_API_USERS_URL } from '../../constants/urls'

export const fetchUser = createAsyncThunk('user/fetchUser', async (id) => {
    const response = await gatewayRequestAxios.get(`${GATEWAY_API_USERS_URL}/${id}?extended_properties=true`)
    return response.data
  })

export const updateUser = createAsyncThunk('user/updateUser', async (updatedUserObj) => {
    const response = await gatewayRequestAxios.put(GATEWAY_API_USER_URL, updatedUserObj)
    return response.data
  })
